/**
 * segColors.js — цвета сегментов в списке вкладки «Сегментация». [12.0.54]
 *
 * ПОВОД. Кружки в списке были свои (красный, зелёный, СИНИЙ, ЖЁЛТЫЙ,
 * ФИОЛЕТОВЫЙ), а маску на снимке красит Cornerstone своей таблицей. На стенде
 * с настоящим движком (tests/стенды/segmentaciya) совпали только первые два:
 * сегмент 3 в списке синий, на снимке — лиловый; 4-й жёлтый против
 * песочного; 5-й фиолетовый против бирюзового. Врач выбирает сегмент по
 * цвету — и выбирал бы не тот. «Только орган в 3D» берёт цвет из кружка, так
 * что и объём красился не тем цветом, что срезы.
 *
 * ИСТОЧНИК ЧИСЕЛ: таблица CORNERSTONE_COLOR_LUT из @cornerstonejs/tools
 * 5.6.3 (src/constants/COLOR_LUT.ts), строки 1…32 — переписаны дословно.
 * Её же берёт движок для каждой новой маски. Сверено на стенде:
 * segmentation.config.color.getSegmentIndexColor отдаёт те же числа.
 * Дальше 32-го сегмента — спрашиваем движок (цветИзДвижка в featureBindings),
 * а пока маски нет — серый, а не выдуманный цвет.
 *
 * Ноль импортов: проверяется в node (tests/segtab_test.mjs).
 * EXPORTS: ЦВЕТА_СЕГМЕНТОВ, цветСегмента, вHex
 */

/** Номер сегмента → [R, G, B] (Cornerstone 5.6.3, COLOR_LUT.ts). Индекс 0 — фон. */
export const ЦВЕТА_СЕГМЕНТОВ = Object.freeze([
  [0, 0, 0],
  [221, 84, 84], [77, 228, 121], [166, 70, 235], [189, 180, 116],
  [109, 182, 196], [204, 101, 157], [123, 211, 94], [93, 87, 218],
  [225, 128, 80], [73, 232, 172], [181, 119, 186], [176, 193, 112],
  [105, 153, 200], [208, 97, 120], [90, 215, 101], [135, 83, 222],
  [229, 178, 76], [122, 183, 181], [190, 115, 171], [149, 197, 108],
  [100, 118, 205], [212, 108, 93], [86, 219, 141], [183, 79, 226],
  [233, 233, 72], [118, 167, 187], [194, 111, 146], [116, 201, 104],
  [115, 96, 209], [216, 147, 89], [82, 223, 188], [230, 75, 224],
].map((ц) => Object.freeze(ц)));

/** [R,G,B] → «#rrggbb». */
export function вHex(ц) {
  if (!Array.isArray(ц) || ц.length < 3) return '#888888';
  return '#' + ц.slice(0, 3).map((ч) => Math.max(0, Math.min(255, Math.round(Number(ч) || 0)))
    .toString(16).padStart(2, '0')).join('');
}

/**
 * Цвет сегмента для кружка в списке.
 * @param {number} номер — 1, 2, …
 * @returns {string} «#rrggbb»; за пределами таблицы — серый (#888888), а не догадка
 */
export function цветСегмента(номер) {
  const н = Math.trunc(Number(номер));
  if (!(н >= 1) || н >= ЦВЕТА_СЕГМЕНТОВ.length) return '#888888';
  return вHex(ЦВЕТА_СЕГМЕНТОВ[н]);
}

export default { ЦВЕТА_СЕГМЕНТОВ, цветСегмента, вHex };
